import React, { useState } from 'react';
import axios from 'axios';
import { Box } from '@chakra-ui/react';
import { Container } from 'components/Container';
import Step1 from 'components/MintPool/step1';
import Step2 from 'components/MintPool/step2';
import Step3 from 'components/MintPool/step3';
import Step4 from 'components/MintPool/step4';
import BackStep from './back';
import { API } from 'config/api';

const Buy = ({
  data,
  access_token,
  user,
  queryQuantity,
  collection = [],
  meta,
  onPaginate,
  transactions = [],
  isLoading,
}) => {
  // console.log('data', data);
  // console.log('queryQuantity', queryQuantity);
  const [step, setStep] = useState(1);
  const [nft, setNft] = useState(null);
  const [updated, setUpdated] = useState(false);
  const [quantity, setQuantity] = useState(1);
  const [loading, setLoading] = useState(false);
  const [intentUsd, setIntentUsd] = useState(null);
  const [intentStx, setIntentStx] = useState(null);

  const props = {
    data,
    access_token,
    setStep,
    nft,
    setNft,
    currentUser: user,
    quantity,
    updated,
    loading,
    intentUsd,
    intentStx,
    collection,
    meta,
    transactions,
    isLoading,
  };
  const onUpdate = (quantity) => {
    setQuantity(quantity);
    console.log('quantity', quantity);
    setLoading(true);
    const config = { headers: { Authorization: `Bearer ${access_token}` } };
    axios
      .all([
        API.post(`nft/mintPool/${data.id}/intent`, { method: 'usd', quantity }, config),
        API.post(`nft/mintPool/${data.id}/intent`, { method: 'stx', quantity }, config),
      ])
      .then(
        axios.spread((data1, data2) => {
          // output of req.
          setUpdated(true);
          setLoading(false);
          setIntentUsd(data1.data.data.authorize_net);
          setIntentStx(data2.data.data.stx_transfer);
        })
      )
      .catch(() => setLoading(false));
  };
  return (
    <Box
      as="section"
      id="card_wave_rider"
      p={{ base: '5px 15px', md: '0px 0px 90px' }}
      bg={step == 4 ? "url('/images/shark-card-bg.svg') no-repeat left center" : ''}
      backgroundPosition={{ base: '100% 35%', md: '29% 50%' }}
    >
      {step === 2 && <BackStep setStep={setStep} />}
      <Container>
        {step === 1 && <Step1 {...props} onUpdate={onUpdate} onPaginate={onPaginate} />}
        {step === 2 && <Step2 {...props} />}
        {step === 3 && <Step3 {...props} />}
        {step === 4 && <Step4 {...props} />}
      </Container>
    </Box>
  );
};

export default Buy;
